import { ColumnModal } from "@/components";
import { useTranslate } from "@/providers/context";

export const DripLockedModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const { translate } = useTranslate();

  return (
    <ColumnModal
      cols={2}
      title={translate("Coming Soon")}
      primaryText={translate("Okay")}
      align="full"
      onOpenChange={setOpen}
      onConfirm={() => setOpen(false)}
      hideClose
      hideTrigger
      open={open}
    >
      <div className="p1-regular p-6 pt-3 text-item-primary">
        {translate("This content is not available yet")}
      </div>
    </ColumnModal>
  );
};
